import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`

export const BlockWrapper = styled.div`
  flex-shrink: 0;

  ${({ theme }) => `
    margin-bottom: ${theme.space.mobile.large};
  `}

  ${({ theme }) => media.sm`
    margin-bottom: ${theme.space.desktop.large};
  `}
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;

  ${media.md`
    flex-direction: row;
  `}
`

export const CompletionProgress = styled.div`
  display: flex;
  width: 100%;
  max-width: 630px;
  flex-shrink: 0;
`

export const ButtonWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;

  ${({ theme }) => `
    margin-top: ${theme.space.mobile.base};

    button {
      margin-top: ${theme.space.mobile.base};
    }
  `}

  ${({ theme }) =>
    media.sm`
    flex-direction: row;

    button {
      margin-right: ${theme.space.desktop.base};

      &:last-child {
        margin-right: 0;
      }
    }
  `}

  ${({ theme }) =>
    media.md`
      margin-top: 0;

      button {
        margin-top: 0;
        margin-right: ${theme.space.desktop.base};

        &:last-child {
          margin-right: 0;
        }
      }
  `}
`
